import axios from 'axios'
import { CADASTAR_USUARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarUsuario (usuario, idEmpresa) {
  const url = `${URL}/usuarios/empresa/${idEmpresa}/cadastrar`;
  return dispatch => axios.post(url,usuario , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTAR_USUARIO,
        payload: response
      })
  );
}
